import { Box, Tooltip, Typography } from "@mui/material";
import { exportIncomeTaxDscRgisters, getIncomeTaxDscRegisters, } from "api/services/automation/income-tax";
import SearchContainer from "components/SearchContainer";
import Table, { ColumnType } from "components/Table";
import sortHandler from "components/Table/SortHandler";
import useTitle from "hooks/useTitle";
import {  useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import { ResType } from "types";
import moment from "moment";
import _ from "lodash";
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import excelIcon from "./../.././assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";



const IncomeTaxDscRegisters = () => {
  useTitle("ATOM Pro | Registered DSC's");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);


  const [sort, setSort] = useState<any>({});

  const { data, isLoading }: ResType = useQuery(
    [
      "income-tax-dsc-register",
      {
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        sort,
      },
    ],
    getIncomeTaxDscRegisters,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
     
    }
  );


  let defaultColumns: Array<ColumnType> = [
   
    // {
    //   key: "category",
    //   sort: true,
    //   active: false,
    //   // direction: SortDirection.ASC,
    //   default: true,
    //   title: (
    //     <Box display="flex" alignItems="center">
    //       {/* <CategoryIcon style={{ width: "20px", marginRight: "5px" }} /> */}
    //       Category
    //     </Box>
    //   ),
    //   render: (v) => {
    //     const categoryLabel =
    //       clientCategories.find((category) => category.value === v?.credentials?.client?.category)?.label || "";

    //     return (
    //       <Typography
    //         sx={{
    //           maxWidth: 90,
    //           whiteSpace: "nowrap",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //         }}
    //         title={categoryLabel}
    //       >
    //         {categoryLabel}
    //       </Typography>
    //     );
    //   },
    // },
    {
      key: "clientId",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      title: (
        <Box display="flex" alignItems="center">
          {/* <PersonOutlineOutlinedIcon style={{ width: "20px", marginRight: "5px" }} />  */}
          Assessee Name (PAN)
        </Box>
      ),
      render: (row) => (
        <Typography
        
          title={`${row?.credentials?.client?.displayName} (${row?.credentials?.panNumber})`}
        >
          {row?.credentials?.client?.displayName} (<span>{row?.credentials?.panNumber}</span>)
        </Typography>
      ),
    },
       {
      key: "fromDate",
      title: "DSC Issue Date",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{moment(Number(row.fromDate)).format("DD MMM YYYY HH:mm")}</Typography>
        );
      },
    },
      {
      key: "issuerDn",
      title: "Issuer Name",
      sort: true,
      active: false,
      default: true,
      render: (row: any) => (
        <Typography   sx={{
            maxWidth: 150,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }} title={row?.issuerDn}>
            
          {row?.issuerDn
            ? row?.issuerDn
            : "--"}
        </Typography>
      ),
    },
    //  {
    //   key: "commonName",
    //   title: "Issuer Name",
    // },
    {
      key: "serialNumber",
      title: "Serial #",
    },
  
      {
      key: "expiryDate",
      title: "DSC Expiry Date",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{moment(Number(row.expiryDate)).format("DD MMM YYYY HH:mm")}</Typography>
        );
      },
    },
      {
      key: "id",
      title: "# Days left to DSC Expiry",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        const expiryMoment = moment(Number(row.expiryDate)).startOf('day');
        const today = moment().startOf('day');

        const diffDays = expiryMoment.diff(today, 'days');
        let expiryText = "";

        if (diffDays === 0) {
          expiryText = "Expiring today";
        } else if (diffDays > 0) {
          expiryText = `Expires in ${diffDays} Day${diffDays > 1 ? "s" : ""}`;
        } else {
          expiryText = `Expired ${Math.abs(diffDays)} Day${Math.abs(diffDays) > 1 ? "s" : ""} ago`;
        }
        return (
          <Typography variant="body1" color={diffDays <= 0 ? "red"  : ''}>{expiryText}</Typography>
        );
      },
    },
    
  
    // {
    //   key: "subjectDn",
    //   title: "Subject DN",
    //   sort: true,
    //   active: false,
    //   default: true,
    //   render: (row: any) => (
    //      <Typography>
    //       {row?.subjectDn
    //         ? row?.subjectDn
    //         : "--"}
    //     </Typography>
    //   ),
    // },
  ];
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));


    const { mutate: mutate1, isLoading: isExporting } = useMutation(exportIncomeTaxDscRgisters, {
      onSuccess: (res: any) => {
        const arr = new Uint8Array(res.data?.data);
        const blob = new Blob([arr], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const file = window.URL.createObjectURL(blob);
        const formattedDateTime = getCurrentFormattedDateTime();
  
        let link = document.createElement("a");
        link.href = file;
        link.download = `ATOM Pro - Income Tax (PAN) DSC Registers ${formattedDateTime}.xlsx`;
        link.click();
        snack.success("Income Tax (PAN) DSC Registers exported successfully");
      },
      onError: (err: any) => {
        snack.error(err);
        snack.error(handleError(err));
      },
    });
    const handleExport = () => {
      if (isExporting) return;
      mutate1({
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        
      });
    };
    
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };
 

  const handleSearch = (e: any) => {
    setSearch(e);
    setPage(0);
  };

  return (
    <Box m={1}>
      <Box  sx={{ display: "flex", justifyContent:'space-between'}}>
     
        <SearchContainer
          minWidth="330px"
          value={search}
          debounced
          placeHolder=" Search by Assessee Name | PAN"
          onChange={handleSearch}
        />
         <Box display="flex" alignItems="center">
                 <Tooltip title={isExporting ? 'Exporting...' : 'Data Export to Excel'}>
                   <img
                     src={excelIcon}
                     alt="Export"
                     style={{
                       cursor: isExporting ? 'not-allowed' : 'pointer',
                       width: 33,
                       height: 33,
                       marginRight: "20px",
                       marginTop: "3px",
                       opacity: isExporting ? 0.5 : 1
                     }}
                     onClick={isExporting ? undefined : handleExport}
                   />
                 </Tooltip>
               </Box>
       
      </Box>

      <Box mt={1}>
        <Table
          sx={{ pb: 0, mb: 0, height: "530px" }}
          pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
          data={data?.data.result || []}
          columns={columns}
          sortHandler={handleSort}
          loading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default IncomeTaxDscRegisters;
